<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">

  <p-accordion id="accordionPerfilRiegos" [multiple]="false" (onOpen)="abrirAcordeon($event)">
    <p-accordionTab header="{{'GARANTIASIDONEAS.LBL_PERIODOGRACIA'|translate}}" [selected]="tabSeleccionado === 'TABPERIDO'">

      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idFormPeriodo" name="nomFormPeriodo">

            <div class="grid form-group">
              <div class="col-12 md:col-3 lg:col-3">
                <div class="div-form">
                  <p-checkbox formControlName="indicadorOpcional" binary="true" (onChange)="validarOpcion()"></p-checkbox>
                  <label class="pl-2">{{'GARANTIASIDONEAS.LBL_OPCIONAL' | translate}}</label>
                </div>
              </div>
              <div class="col-12 md:col-3 lg:col-3" >
                <div class="div-form">
                  <label>* {{ 'GARANTIASIDONEAS.LBL_PERIODOMINIMO' | translate }}</label>
                  <input type="text" pInputText id="periodoMinimo"
                         name="nomPeriodoMinimo"
                         autocomplete="off"
                         formControlName="periodoMinimo"
                         numero-entero-reactive
                         [maxlength]="3"
                         *ngIf="opcion"
                         (blur)="validarPlazos()"
                  >
                  <div *ngIf="!opcion">
                    <label class="falso-combo-texto">{{f.periodoMinimo.value}}</label>
                  </div>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.periodoMinimo.invalid">
                    {{ 'GARANTIASIDONEAS.LBL_PERIODOMINIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="!rangoMininoValido">
                    {{ 'GARANTIASIDONEAS.MSG_ERRORRANGOPERIDO' | translate }}
                  </div>
                </div>
              </div>

              <div class="col-12 md:col-3 lg:col-3">
                <div class="div-form">
                  <label>* {{ 'GARANTIASIDONEAS.LBL_PERIODOMAXIMO' | translate }}</label>
                  <input type="text" pInputText id="periodoMeses"
                         name="nomPeriodoMeses"
                         autocomplete="off"
                         formControlName="periodoMaximo"
                         numero-entero-reactive
                         [maxlength]="3"
                         (blur)="validarPlazos()"
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.periodoMaximo.invalid">
                    {{ 'GARANTIASIDONEAS.LBL_PERIODOMAXIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>

              <div class="col-12 md:col-3 lg:col-3">
                <div class="div-form">
                  <label>{{'GARANTIASIDONEAS.LBL_PERIODOGRACIA' | translate}}</label>
                  <p-dropdown disableTab  id="idTipoPeriodoGracia" name="nomTipoPeriodoGracia" [options]="lisTiposPeriodoGraciaTodos"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                               formControlName="idTipoPeriodoGracia"

                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoPeriodoGracia.invalid">
                    {{ 'GARANTIASIDONEAS.LBL_PERIODOGRACIA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>


              <div class="col-12 md:col-3 lg:col-3">
                <div class="div-form">
                  <p-checkbox formControlName="indicadorIntereses" binary="true"></p-checkbox>
                  <label class="pl-2">{{'GARANTIASIDONEAS.LBL_PERIODOINTERESES' | translate}}</label>
                </div>
              </div>

              <div class="col-12 md:col-3 lg:col-3">
                <div class="div-form">
                  <p-checkbox formControlName="indicadorCapital" binary="true"></p-checkbox>
                  <label class="pl-2">{{'GARANTIASIDONEAS.LBL_PERIODOCAPITAL' | translate}}</label>
                </div>
              </div>
              <div class="col-12 md:col-3 lg:col-3">
                <div class="div-form">
                  <p-checkbox formControlName="indicadorOtrosConceptos" binary="true" ></p-checkbox>
                  <label class="pl-2">{{'GARANTIASIDONEAS.LBL_PERIODOOTROSCONCEPTOS' | translate}}</label>
                </div>
              </div>
            </div>
            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <div *ngIf="!guardando">
                  <button icon="fa fa-plus" *ngIf="!edit"
                          label="{{'BTN_AGREGAR' | translate }}"
                          type="submit"
                          pButton></button>

                  <button icon="fa fa-plus" *ngIf="edit"
                          label="{{'BTN_EDITAR' | translate }}"
                          type="submit"
                          pButton></button>
                </div>

                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_GUARDANDO' | translate }}</span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </p-accordionTab>

    <p-accordionTab header="{{'GARANTIASIDONEAS.LBL_PERIODOCONCEPTOS'|translate}}"
                    [selected]="tabSeleccionado === 'TABCONCEPTOS'"
                    *ngIf="edit && indicadorConpeptos">

      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <form [formGroup]="formularioConceptos" (ngSubmit)="onSubmitConpetos()" novalidate id="idFormConceptos" name="nomFormConceptos">
            <div class="grid form-group" >
              <div class="col-12 md:col-12 lg:col-4">
                <div class="div-form">
                  <label>* {{'GARANTIASIDONEAS.LBL_PERIODOCONCEPTOS' | translate}}:</label>

                  <p-multiSelect id="idCanal" name="nomCanal" [options]="conceptoFacturacion"
                                 filter="filter"
                                 defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                                 selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
                                 formControlName="conceptos"
                                 emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                 optionValue="value"
                                 optionLabel="label"
                  ></p-multiSelect>
                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="submitted && c.conceptos.invalid">
                    {{ 'GARANTIASIDONEAS.LBL_PERIODOCONCEPTOS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <div *ngIf="!guardando">
                  <button icon="fa fa-plus"
                          label="{{'BTN_AGREGAR' | translate }}"
                          type="submit"
                          pButton></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_GUARDANDO' | translate }}</span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <div class="grid form-group">
            <div class="col-12 md:col-12 lg:col-12">
              <p-table [columns]="columnas" [loading]="carTabla" #dt
                       [value]="getGarantiasIdoneasPeriodoConcepto"
                       selectionMode="single" dataKey="idGarantiaIdoneaPGConceptoFacturacion"
                       [paginator]="true" [rows]="10"  paginatorPosition="bottom">
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                        class="text-center">
                      {{col.header}}
                      <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                  <tr [pSelectableRow]="row">
                    <td class="table-break">{{row.codigoConceptoFacturacion}}</td>
                    <td class="table-break">{{row.conceptoFacturacion}}</td>
                    <td class="text-center">
                      <div class="btn-group" role="group">
                        <button type="button" class="p-button p-button-danger btn" icon="fa fa-trash" data-toggle="tooltip"
                                title="{{'BTN_DESHABILITAR' | translate}}" pButton
                                (click)="disable(row)" ></button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="columns.length">
                      {{ 'MSG_NOHAYREGISTROS' | translate}}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>
    </p-accordionTab>
  </p-accordion>
</div>
<p-confirmDialog #cd key="garantia-idoneas-concepto" appendTo="body">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

